import store from '@/store'
import elementI18nZhCn from 'element-plus/es/locale/lang/zh-cn'
import elementI18nEn from 'element-plus/es/locale/lang/en'
import { ref, Ref, watch } from 'vue'

interface useElementLocal {
  locale: Ref<typeof elementI18nZhCn> | Ref<typeof elementI18nEn>
  switchElementLocale: (lang: 'zh_cn' | 'en') => void
}

export function useElementLocal(): useElementLocal {
  const locale = ref(store.state.lang === 'en' ? elementI18nEn : elementI18nZhCn)

  watch(
    () => store.state.lang,
    (newLang) => {
      locale.value = newLang === 'en' ? elementI18nEn : elementI18nZhCn
    },
    { immediate: true },
  )
  const switchElementLocale = (lang: 'zh_cn' | 'en') => {
    locale.value = lang === 'zh_cn' ? elementI18nZhCn : elementI18nEn
  }
  return {
    locale,
    switchElementLocale,
  }
}
